<template>
  <div>
    <v-form @submit.prevent="signin" ref="form" lazy-validation v-model="valid">
      <v-text-field
        v-model="email"
        name="email"
        :label="$t('labels.email')"
        :rules="emailRules"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        type="password"
        name="password"
        :label="$t('labels.password')"
        :rules="passwordRules"
        required
      ></v-text-field>

      <div><router-link :to="{ name: 'recover' }" v-text="$t('recover')"></router-link></div>
      <div><router-link :to="{ name: 'resend' }" v-text="$t('resend')"></router-link></div>

      <v-row align="center" justify="center" class="mt-1">
        <v-btn x-large color="primary" type="submit" :disabled="!valid" v-text="$t('play')"></v-btn>
      </v-row>
    </v-form>

    <v-divider class="mt-5 mb-5"></v-divider>

    <v-row align="center" justify="center">
      <v-col align="center">
        <v-btn large fab class="mr-3" @click="signinSocial('google')">
          <v-icon>mdi-google</v-icon>
        </v-btn>
      </v-col>
      <v-col align="center">
        <v-btn large fab class="mr-3" @click="signinSocial('facebook')">
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
      </v-col>
      <v-col align="center">
        <v-btn large fab class="mr-3" @click="signinSocial('vk')">
          <v-icon>mdi-vk</v-icon>
        </v-btn>
      </v-col>
      <v-col align="center">
        <v-btn large fab @click="signinSocial('ok')">
          <v-icon>mdi-odnoklassniki</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'signin',
  data () {
    return {
      valid: true,
      email: null,
      emailRules: [
        v => !!v || this.$t('validations.email_required'),
        v => /.+@.+\..+/.test(v) || this.$t('validations.email_invalid')
      ],
      password: null,
      passwordRules: [
        v => !!v || this.$t('validations.password_required'),
        v => (v && v.length >= 6) || this.$t('validations.password_invalid')
      ]
    }
  },
  methods: {
    signin () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$store.dispatch('auth/process', {
        type: 'signin',
        callback: document.location.origin + this.$router.resolve({ name: 'auth' }).href,
        payload: {
          password: this.password,
          remember_me: true,
          username: this.email
        }
      }).then((res) => {
        this.email = null
        this.password = null
      }).catch((e) => {
        this.$store.dispatch('addError', e.message)
      })
    },

    signinSocial (provider) {
      this.$store.dispatch('auth/process', {
        type: `social_${provider}`,
        callback: document.location.origin + this.$router.resolve({ name: 'auth' }).href
      }).then((res) => {
        this.email = null
        this.password = null
      }).catch((e) => {
        this.$store.dispatch('addError', e.message)
      })
    }
  }
}
</script>
